import { type GetStaticProps, type NextPageWithLayout } from 'next';
import { withPageAuth } from '@/lib/auth/HOC/withPageAuth';
import { getProfileSidebarLayout } from '@/module/profile/layout/ProfileSidebarLayout';
import { VoucherPage } from '@/module/voucher';
import { getDefaultStaticProps } from '@/utils/next';
import { STATIC_PAGE_REVALIDATE_SECONDS } from '@/utils/next/getDefaultServerSideProps';
const Voucher: NextPageWithLayout = () => {
  return <VoucherPage data-sentry-element="VoucherPage" data-sentry-component="Voucher" data-sentry-source-file="index.page.tsx" />;
};
Voucher.getLayout = function (page) {
  return getProfileSidebarLayout(page);
};
export default withPageAuth(Voucher, {
  callbackUrl: '/voucher'
});
export const getStaticProps = (async ctx => {
  return {
    props: {
      ...(await getDefaultStaticProps({
        ...ctx,
        namespaces: ['common', 'billing']
      })).props
    },
    revalidate: STATIC_PAGE_REVALIDATE_SECONDS
  };
}) satisfies GetStaticProps;